import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'
import type { Device } from '@/stores/device/api'
import { isWhitelistError } from '@/utils/api/whitelist'

export async function loadDevices() {
  try {
    const url = withPbx('devices')

    const { data } = await http.get<Device[]>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function updateDevices(inputData: any) {
  try {
    const url = withPbx('devices')

    const { data } = await http.patch(url, inputData)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function searchDevices(deviceIds: number[]) {
  try {
    const url = withPbx('devices/search')

    const { data } = await http.post(url, { deviceIds })

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function deleteDevices(deviceIds: number[]) {
  try {
    const url = withPbx('devices')

    const { data } = await http.delete(url, { params: { deviceIds } })

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
